import { Link } from 'react-router-dom';
import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import './App.css';

export default function Donate() {
  const { page } = useParams();
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    // Set loaded to true after a short delay to allow animations to occur
    const timeout = setTimeout(() => {
      setLoaded(true);
    }, 500);

    return () => clearTimeout(timeout);
  }, []);

  useEffect(() => {
    // Scroll to the top of the page
    window.scrollTo(0, 0);
  }, [page])

  return (
    <div className={`bg-black h-auto ${loaded ? 'slide-in' : ''}`}>
      <div className="py-4 max-w-lg mx-auto text-center mb-4">
        <h1 className="text-3xl sm:text-4xl font-bold text-red-600 mb-4">Be Involved</h1>
        <p className="text-base sm:text-lg text-white">
          Your creativity could inspire groundbreaking contributions to our projects. Don't hesitate to share your innovative ideas.
        </p>
        <p className="text-base sm:text-lg text-white">
          Would you want to volunteer or partner with us? Email us at <a href="mailto:baloziwaamaniinitiative@gmail.com" className="text-red-600">baloziwaamaniinitiative@gmail.com</a>   and will get back to you as soon as possible.
        </p>

        <Link to="/contact">
          <button className='text-white px-2 bg-red-700 rounded-md text-base py-2 self-start transition-transform transform hover:scale-110'>Contact Us</button>
        </Link>
        
      </div>
      <div className='py-4 px-6 bg-gray-200'>
        <h1 className='text-3xl font-bold text-orange-700 text-center'>Donate With Confidence</h1>
        <h3 className='py-2 text-black font-bold text-center text-xl'>We ensure a simple donation process:</h3>
        <h1 className='text-lg font-bold text-orange-700 text-center py-2'>Donate online with Mpesa. (Other methods of payment coming soon...)</h1> 
        <div className='flex flex-col sm:flex-row items-center  flex items-center justify-center'>
          <img src="images/mpesa.png" className=" w-64 h-50" alt="mpesa logo" />
          <div className="ml-2 sm:ml-0 ">
            <h3 className='text-base md:mt-0 font-bold '> <span className='text-red-800 text-xl font-bold'>PHONE NO: </span>0722693423 (Send money)</h3>
            <h3 className='py-4 text-sm md:mt-0 text-base font-bold'><span className='text-red-800 text-lg font-bold'> ACCOUNT NAME: </span> JUDY GATHUITA (Finance Director)</h3>
          </div>
        </div>
      </div>
    </div>
  );
}
